import { h, Fragment } from 'preact';
import { getEnv } from 'mobx-easy';
import { RootEnv } from '../../helpers/create-store';

interface Props {
	text: string;
	args?: {};
}

const Translate = ({ text, args }: Props) => {
	const translation = getTranslationText(text, args);

	return <Fragment>{translation}</Fragment>;
};

export const getTranslationText = (text: string, args?: {}): string =>
	getEnv<RootEnv>().langService.translate(text, args);

export default Translate;
